import { StyleSheet } from "aphrodite";
const styles = StyleSheet.create({
  grid: {
    padding: "",
    margin: "0",
    minHeight: "calc(100vh - 100px)"
  },
  flexRow: {
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "-9px"
  },
  row: {
    paddingBottom: "13px",
    padding: "",
    margin: "0"
  },
  gridRow: {
    padding: "13px",
    margin: "0"
  },
  headerDiv: {
    fontFamily: "roboto",
    fontWeight: "300",
    fontSize: "12px",
    display: "inline-block",
    marginRight: "15px"
  },
  headerSpan: {
    fontSize: "16px",
    fontWeight: "600"
  },
  buttonsWrap: {
    float: "right",
    width: "50%"
  },
  pdfButton: {
    float: "right",
    marginLeft: "4.76%",
    fontSize: "24px",
    color: "#fff",
    padding: "3px 4px",
    borderRadius: "0",
    backgroundColor: "#0b4687",
    marginTop: "13px"
  },
  pdfButtonSpan: {
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "10px",
    textAlign: "left",
    lineHeight: "1em"
  },
  span: {
    background: "#f6f6f6",
    borderLeft: "1px solid #ccc",
    borderRight: "1px solid #ccc",
    display: "inline-block",
    verticalAlign: "middle",
    height: "25px",
    lineHeight: "25px",
    fontSize: "11px",
    fontFamily: "Roboto, sans-serif",
    padding: "0 .6em",
    cursor: "default"
  },
  allPatientsPageWrap: {
    padding: "0 10px",
    backgroundColor: "#F2F2F2"
  },
  breadcrumbs: {
    marginBottom: "31px",
    padding: "0",
    backgroundColor: "transparent"
  },
  error: {
    color: "#ff0000",
    fontSize: "18px",
    marginTop: "25px",
    textAlign: "center"
  },
  iconOpacity: {
    maxWidth: 24,
    maxHeight: 24
  },
  day: {
    paddingLeft: "1%",
    paddingRight: "1%",
    fontSize: "16px",
    cursor: "pointer",
    "@media (max-width: 767.98px)": {
      fontSize: "12px",
    },
  },
  monthLeft: {
    paddingLeft: "0.5%",
    paddingRight: "0.5%",
    cursor: "pointer"
  },
  monthRight: {
    paddingLeft: "0.5%",
    paddingRight: "0.5%",
    cursor: "pointer"
  },
  selectedDate: {
    backgroundColor: "#fff",
    borderRadius: "50%",
    color: "#000",
    width: "28px",
    lineHeight: "16px",
    verticalAlign: "middle",
    padding: "5px",
    textAlign: "center",
    alignContent: "center"
  },
  timelineIcon: {
    paddingLeft: "0.83%",
    paddingRight: "0.8%",
    fontSize: "16px",
    cursor: "pointer",
    textAlign: "center",
    alignContent: "center"
  },
  timelineIconBg: {
    borderRadius: "50%",
    verticalAlign: "middle",
    padding: "6px",
    width: "25px"
  },
  timelineIconBgWithoutPadding: {
    borderRadius: "50%",
    verticalAlign: "middle",
    width: "25px"
  },
  timelineIconBgRed: {
    backgroundColor: "#C90000"
  },
  timelineIconBgGreen: {
    backgroundColor: "#00BC41"
  },
  vLine: {
    backgroundImage: "url(/images/diary/vLine.png)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  },
  triangleDown: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "15px solid #4E4E4E"
  },
  show: {
    display: "block"
  },
  hide: {
    display: "none"
  },
  selectedRow: {
    backgroundColor: "#E7E3E3"
  },
  divDateFilter: {
    position: "absolute",
    right: "20px",
    zIndex: "999",
    backgroundColor: "#fff",
    padding: "20px",
    color: "#222222",
    minWidth: "290px",
    textAlign: "left",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1) !important",
    marginTop: "13px"
  },
  divFilter: {
    position: "absolute",
    right: "20px",
    zIndex: "999",
    backgroundColor: "#fff",
    color: "#222222",
    /*minWidth: "320px",
    width: "320px",*/
    minWidth: "400px",
    width: "400px",
    maxWidth: "600px",
    textAlign: "left",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1) !important",
    marginTop: "50px",
    maxHeight: "500px",
    //overflowX: "scroll",
    //overflowY: "scroll"
  },
  divFilterExtended: {
    width: "43%"
  },
  // divFilter: {
  //   width: "25%"
  // },
  yearDiv: {
    background: "#E7E7E7"
  },
  overflowBoth: {
    //overflowX: "scroll",
    //overflowY: "scroll"
  },
  extendedDiaryLeftDetails: {
    float: "left",
    width: "50%",
    height: "500px"
  },
  extendedDiaryRightDetails: {
    float: "right",
    width: "50%",
    /*height: "100%"*/
    height: "500px"
  },
  iconsMenu: {
    color: "#fff",
    fontSize: "20px",
    marginRight: "30px",
    cursor: "pointer"
  },
  /*divIcons: {
    float: "right",
    marginTop: "8px",
    marginRight: "30px"
  },*/
  imageiconsMenu: {
    width: "24px",
    cursor: "pointer",
    borderBottom: "2px solid transparent"
  },
  divIcons: {
    textAlign: "right",
    paddingRight: "4px",
    paddingTop: "5px"
  }
});

export default styles;
